/*CUSTOMIZATIONS:
- used v2 image component*/

import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import cx from 'classnames';
import { UniversalLink } from '@plone/volto/components';
import RenderContentContent from 'volto-repeatable-content-block/RepeatableContentBlock/RenderContentContent';
import 'volto-repeatable-content-block/RepeatableContentBlock/style.css';
import Image from '@plone/volto/components/theme/Image/Image';

const messages = defineMessages({
  emptyBlock: {
    id: 'emptyBlock',
    defaultMessage:
      "Attention: This content does not have any content. The title and description are not considered content and won't be showed",
  },
});

const Body = ({ content, edit, data }) => {
  const intl = useIntl();

  const showContentText = data.showContentText ?? true;

  let renderContent = showContentText
    ? RenderContentContent({ content: content })
    : null;

  const showHeader =
    data.showContentTitle ||
    data.showContentDescription ||
    data.showContentImage;

  const ContentInfosWrapper = ({ showImage, children }) => {
    return showImage ? (
      <UniversalLink item={!edit ? content : null} href={edit ? '#' : null}>
        {children}
      </UniversalLink>
    ) : (
      <>{children}</>
    );
  };

  const showImage =
    data.showContentImage && (content?.preview_image || content?.image);

  return showHeader || renderContent ? (
    <>
      {content && showHeader && (
        <div className="repeatable-block-header">
          {showImage && (
            <div
              className={cx('repeatable-block-image', {
                'full-width': data.imageFullWidth,
              })}
            >
              <UniversalLink
                item={!edit ? content : null}
                href={edit ? '#' : null}
              >
                <Image
                  image={content.preview_image || content.image}
                  alt=""
                  className="img-fluid"
                />
              </UniversalLink>
            </div>
          )}
          {((data.showContentTitle && content.title) ||
            (data.showContentDescription && content.description)) && (
            <ContentInfosWrapper showImage={showImage}>
              <div
                className={cx('repeatable-block-content-infos', {
                  'no-bg': renderContent != null || !showImage,
                })}
              >
                {data.showContentTitle && (
                  <h2 className="repeatable-block-title">{content.title}</h2>
                )}
                {data.showContentDescription && (
                  <div className="repeatable-block-description">
                    {content.description}
                  </div>
                )}
              </div>
            </ContentInfosWrapper>
          )}
        </div>
      )}
      {renderContent ?? <></>}
    </>
  ) : edit ? (
    <p className="empty-selection">{intl.formatMessage(messages.emptyBlock)}</p>
  ) : (
    <></>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Body.propTypes = {
  content: PropTypes.objectOf(PropTypes.any),
};

export default Body;
